import firebase from "firebase/compat/app";
import "firebase/compat/auth";

import { getHost } from "./StripeData";

/**
 * POST multipart /api/v1/import-training-plan
 * @param {FormData} formData — must include "file"; optional "planName", "clientUID",
 *   "appendToProtocolId" (append workouts to an existing plan instead of creating a new protocol),
 *   "importSource" ("generic" | "everfit" — optional extraction profile; default generic)
 * @returns {Promise<{ success: boolean, protocolId: string, planName: string, appendMode?: boolean, importSource?: string, stats: object }>}
 */
export async function importTrainingPlan(formData) {
  const user = firebase.auth().currentUser;
  if (!user) {
    throw new Error("User not authenticated");
  }
  const token = await user.getIdToken();
  const base = getHost();
  const response = await fetch(`${base}/api/v1/import-training-plan`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });

  const result = await response.json().catch(() => ({}));
  if (!response.ok || !result.success) {
    throw new Error(result.error || "Training plan import failed");
  }
  return result;
}
